// CurrentUser context — provides role/permission info to the frontend.
// Backed by GET /api/v1/auth/me with 5-min staleness.
// While loading, all permissions return true to prevent flash of empty nav.

import { createContext, useContext } from 'react'
import type { CurrentUser, PermissionPage } from '@portico/types'

export interface CurrentUserContextValue {
  user: CurrentUser | null
  isLoading: boolean
  /** Check if user can view a specific page */
  canView: (page: PermissionPage) => boolean
  /** Check if user can edit on a specific page */
  canEdit: (page: PermissionPage) => boolean
  /** Check if user has a specific role */
  hasRole: (role: string) => boolean
}

export const CurrentUserContext = createContext<CurrentUserContextValue>({
  user: null,
  isLoading: true,
  canView: () => true,  // default: allow while loading
  canEdit: () => true,
  hasRole: () => false,
})

export function useCurrentUser(): CurrentUserContextValue {
  return useContext(CurrentUserContext)
}
